import styled from "styled-components";
import { BodySmall } from "../typography/styled";

type LegendProp = {
  second?:boolean
}
type ChartLineProp = {
  $second?:boolean
}
type ActiveOverlay = {
  active: boolean
}

export const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: 
    radial-gradient(farthest-side, ${({theme}) => theme.accent[100]} 94%,#0000) top/8px 8px no-repeat,
    conic-gradient(#0000 30%, ${({theme}) => theme.accent[100]});
  mask: radial-gradient(farthest-side,#0000 calc(100% - 4px),#000 0);
  animation:s3 1s infinite linear;

@keyframes s3{ 
  100%{transform: rotate(1turn)}
}
`
export const HeadWrapper = styled.div`
  display: flex;
  width:100%;
  min-width: 0;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;
  }
`

export const MetricSettingsTitle = styled(BodySmall)`
  color:${({theme}) => theme.palette[700]};
`
export const RadioWrapper = styled.div`
  display: flex;
  /* width: 316px; */
  position: relative;
  min-width: 0;
  max-width: 100%;

  @media screen and (max-width: 768px) {
    width: 100%;
    overflow: visible;
  }
`

export const LeftSideData = styled.div`
  position: relative;
  height: var(--plot-height);
  margin: 10px 0;
  width: 88px;
  min-width: 88px;

  @media screen and (max-width: 768px) {
    width: 72px;
    min-width: 72px;
  }
`
type LabelProps = {
  orientation?:boolean;
}
export const LabelMetric = styled.div<LabelProps>`
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  position: absolute;
  /* right: ${({orientation}) => orientation ? '' : '0px'};
  left: ${({orientation}) => orientation ? '0px' : ''}; */
  /* width: 200px; */
  z-index:999 !important;
  background-color: ${({theme}) => theme.palette[10]};
  justify-content:center;
  border-radius: ${({theme}) => theme.radius.xs};
  white-space: nowrap;
  border:  ${({theme}) => `1px solid ${theme.grey[350]}`};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
  /* box-shadow:0px 2px 10px rgba(0, 0, 0, 0.1); */
`
export const MetricData = styled(MetricSettingsTitle)`
  text-transform: uppercase;
  white-space: nowrap;
  margin-top: 15px;
  padding-right: 8px;
  text-align: right;
`
type YAxisMetricDataProps = {
  $position: number;
}
export const YAxisMetricData = styled(MetricSettingsTitle)<YAxisMetricDataProps>`
  position: absolute;
  top: ${({$position}) => `${$position}%`};
  right: 0;
  max-width: 100%;
  padding-right: 8px;
  transform: translateY(-50%);
  text-align: right;
  text-transform: uppercase;
  white-space: nowrap;

  @media screen and (max-width: 768px) {
    font-size: 11px;
  }
`
type DateMetricDataProps = {
  $position: number;
}
export const DateMetricData = styled(MetricData)<DateMetricDataProps>`
  position: absolute;
  top: 0;
  left: ${({$position}) => `${$position}%`};
  transform: translateX(${({$position}) => $position <= 0 ? '0' : $position >= 100 ? '-100%' : '-50%'});
  padding-right: 0;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 11px;
  }
`
export const ChartWrapper = styled.div`
  display: flex;
  margin-top: 10px;
  position: relative;
  width: 100%;
  min-width: 0;
`
export const Overlay = styled.div<ActiveOverlay>`
  position:absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% + 2px);
  height: 100%;
  z-index: 10;
  display: ${({active}) => active ? 'flex' : 'none'};
  background: ${({active, theme}) => active ? theme.isDark ? 'rgba(36, 36, 36, 0.7)' : 'rgba(255, 255, 255, 0.7)' : ''};
`
export const AreaContainer = styled.div`
  display: flex;
  flex-direction: column;
  width:100%;
  min-width: 0;
  height:100%;
`

export const BottomData = styled.div`
  grid-column: 2;
  position: relative;
  height: 35px;
  min-width: 0;
`
type AreaTypes = {
  data?:any
}

export const Area = styled.div<AreaTypes>`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  background: linear-gradient(180deg, rgba(40, 148, 255, 0.5) 0%, rgba(217, 217, 217, 0) 100%);
  clip-path: ${({data}) => `polygon(
    ${data},
    100% 100%,
    0% 100%
  )`};
`

export const Area2 = styled.div<AreaTypes>`
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
  background: ${({theme}) => theme.isDark
    ? 'linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%)'
    : 'linear-gradient(180deg, rgba(8, 29, 66, 0.24) 0%, rgba(8, 29, 66, 0) 100%)'};
  clip-path: ${({data}) => `polygon(
    ${data},
    100% 100%,
    0% 100%
  )`};
`
export const GraphWrapper = styled.div`
  display:flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  min-width: 0;
  height:100%;
`
export const PlotRow = styled.div`
  --plot-height: 245px;
  --grid-step: 35px;
  display: grid;
  grid-template-columns: 88px minmax(0, 1fr);
  column-gap: 10px;
  width: 100%;
  min-width: 0;
  padding-right: 50px;
  box-sizing: border-box;
  position: relative;

  @media screen and (max-width: 768px) {
    --plot-height: 210px;
    --grid-step: 30px;
    grid-template-columns: 72px minmax(0, 1fr);
    column-gap: 8px;
    padding-right: 0;
  }
`
export const AreaTop = styled.div`
  height: var(--plot-height);
  margin: 10px 0;
  display: flex;
  width: 100%;
  min-width: 0;
  flex-direction: column;

  background: ${({theme}) => `repeating-linear-gradient(
      to bottom,
      ${theme.grey[350]} 0,
      ${theme.grey[350]} 1px,
      transparent 1px,
      transparent var(--grid-step)
    )`};
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
  box-sizing: border-box;

  &>div{
    height:100%;
    position: relative;
  }
`
type ChartDotTypes = {
  second?:boolean
}
export const ChartDot = styled.div<ChartDotTypes>`
  width: 5px;
  height:5px;
  border-radius: 100%;
  position: absolute;
  color: ${({theme, second}) => second ? theme.isDark ? theme.base.black : '#081D42' : theme.accent[100]};
  background-color: ${({theme, second}) => second ? theme.isDark ? theme.base.black : '#081D42' : theme.accent[100]};
  box-shadow: ${({theme}) => theme.shadows.control};
  z-index: 3;
  transform:translateX(-50%) translateY(50%);
  transition: transform 120ms ease, box-shadow 120ms ease;

  &::before {
    content: '';
    position: absolute;
    inset: -9px;
    border-radius: 100%;
  }

  &>div{
    position: relative;
    z-index:-2;
  }
  &:hover{
    cursor:pointer;
    z-index: 4;
    transform:translateX(-50%) translateY(50%) scale(1.6);
    box-shadow: 0 0 0 2px ${({theme}) => theme.palette[10]}, 0 0 0 4px currentColor;
  }
`

export const ChartLine = styled.svg<ChartLineProp>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  overflow: visible;
  pointer-events: none;
  color: ${({theme, $second}) => $second ? theme.isDark ? theme.base.black : '#081D42' : theme.accent[100]};

  polyline {
    fill: none;
    stroke: currentColor;
    stroke-width: 2;
    vector-effect: non-scaling-stroke;
  }
`

export const LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 7px;
  height: 23px;
  background: ${({theme}) => theme.palette[200]};
  border-radius: ${({theme}) => theme.radius.xs};
  margin-right:8px;
`
export const TraficText = styled(BodySmall)`
  font-weight: 500;
  color:${({theme}) => theme.palette[900]};
  text-transform:uppercase;
  margin-left: 8px;
`
type NameProps = {
  inactive?: boolean,
}
export const TraficName = styled(BodySmall)<NameProps>`
  color:${({theme}) => theme.palette[700]};
  text-decoration: ${({inactive}) => inactive ? 'line-through' : ''};
`

export const TraficDot = styled.div<LegendProp>`
  width: 8px;
  height: 8px;
  border-radius: 100%;
  margin-right: 6px;
  background-color: ${({second, theme}) => second ? theme.isDark ? theme.base.black : '#081D42' : theme.accent[100]};
`

export const LegendWrapper = styled.div`
  display: flex;
  margin-top:17px;
`

type VerticalBorderProps = {
  $position: number;
}
export const VerticalBorder = styled.div<VerticalBorderProps>`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${({$position}) => `${$position}%`};
  z-index: 1;
  border-left: ${({theme}) => `1px solid ${theme.grey[350]}`};
`
